/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {createSelector} from 'reselect';
import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
import {Account, User} from '@ion/core/src/types/entities';
import {LoginReducerState} from '@/store/types';

// eslint-disable-next-line no-barrel-files/no-barrel-files
export * from '@ion/applications/src/pages/login/state-selectors';

// input selectors ...
const selectUser               = ({login}) => login.user;
const selectUserAccount        = ({login}) => login.account;
const selectIsAuthenticating   = ({login}) => login.isAuthenticating;
const selectIsForbidden        = ({login}) => login.isForbidden;
const selectIsAuthenticated    = ({login}) => login.authenticated;
const selectHasIonSuite        = ({login}) => login.isSuiteOnly || login.hasPreviewFeature;
const selectPersistCredentials = ({login}) => login.persistCredentials;
const selectIsInvalid          = ({login}) => login.isInvalid;
const selectHasPreviewFeature  = ({login}) => login.hasPreviewFeature;
const selectIsSuiteOnly        = ({login}) => login.isSuiteOnly;
const selectSystemOfUnits      = ({login: {user}}: LoginReducerState) => user.systemOfUnits;
export const selectUsername    = ({login}) => login.user.username;

// output selectors ...
export const userSelector = createDeepEqualSelector(selectUser,
  (user: User): User => user
);

export const usernameSelector = createSelector(selectUsername,
  (username: string): string => username
);

export const isAuthenticatingSelector = createSelector(selectIsAuthenticating,
  (isAuthenticating: boolean): boolean => isAuthenticating
);

export const isAuthenticatedSelector = createSelector(selectIsAuthenticated,
  (authenticated: boolean): boolean => authenticated
);

export const hasIonSuiteSelector = createSelector(selectHasIonSuite,
  (hasiOnSuite: boolean): boolean => hasiOnSuite
);

export const persistCredentialsSelector = createSelector(selectPersistCredentials,
  (persistCredentials: boolean): boolean => persistCredentials
);
export const hasPreviewFeatureSelector = createSelector(selectHasPreviewFeature,
  (hasPreviewFeature: boolean): boolean => hasPreviewFeature
);
export const isSuiteOnlySelector = createSelector(selectIsSuiteOnly,
  (isSuiteOnly: boolean): boolean => isSuiteOnly
);

export const systemOfUnitsSelector = createDeepEqualSelector(selectSystemOfUnits,
  (systemOfUnits: any): any => systemOfUnits
);

export const previewFeatureSelector = createSelector([selectIsSuiteOnly, hasPreviewFeatureSelector],
  (iSuiteOnly: boolean, hasPreviewFeature: boolean) => !iSuiteOnly && hasPreviewFeature
);

export const isInvalidSelector = createDeepEqualSelector(selectIsInvalid,
  (isInvalid: boolean): boolean => isInvalid
);

export const userAccountSelector = createSelector(selectUserAccount,
  (account: Account): Account => account
);

export const isForbiddenSelector = createSelector(selectIsForbidden,
  (isForbidden: boolean): boolean => isForbidden
);
